export const ASSISTANT_INSIGHTS = "ASSISTANT_INSIGHTS";
export const ASSISTANT_AGENT = "ASSISTANT_AGENT";

export type AssistantMode = "AGENT" | "INSIGHTS";

type FeatureHolder = { features?: string[] } | null | undefined;

export function hasFeature(member: FeatureHolder, feature: string): boolean {
  return !!member?.features?.includes(feature);
}

export function assistantMode(member: FeatureHolder): AssistantMode | null {
  if (hasFeature(member, ASSISTANT_AGENT)) return "AGENT";
  if (hasFeature(member, ASSISTANT_INSIGHTS)) return "INSIGHTS";
  return null;
}
